// src/components/Dispatchdetails/Dispatchdetails.jsx
import {
  lazy,
  Suspense,
  startTransition,
  useMemo,
  useEffect,
  useRef,
  useState,
} from "react";
import { db } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  updateDoc,
  arrayUnion,
  onSnapshot,
} from "firebase/firestore";
import EditIcon from "@mui/icons-material/Edit";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Divider,
  Grid2,
  LinearProgress,
} from "@mui/material";
import { TextField } from "@mui/material";
import { format } from "date-fns";

import { useNavigate, useParams } from "react-router-dom";

import PrintIcon from "@mui/icons-material/Print";
import {
  translateStatesBicciFilter,
  translateStatesfalabbela,
  translateStatesSendsFalabbelaSelector,
} from "../../utils/objects/translateStates";
import {
  stlyleClassStates,
  styleState,
} from "../../utils/objects/stylesStates";

import HandlePrintBiccShipping from "../../utils/HandlePrintBiccShipping/HandlePrintBiccShipping";
import { useOrders } from "../../hooks/useOrdersProviders/OrdersContext";
import Moment from "moment";
import {
  getDocumentAndHistory,
  subscribeDocumentAndHistory,
} from "../../utils/UtilsOrders/getDocumentAndHistory";
import useGetDataRiderByCompany from "../../hooks/getDataRiderByCompany";

import LiberarOrden from "../Dashboard/LiberarOrden/LiberarOrden";
import ContainerViewComponent from "../ContainerViewComponent/ContainerViewComponent";
import { useLoadScript } from "@react-google-maps/api";
import { useDrivers } from "./useDrivers";

//import MapDeliveryPosition from "./MapDeliveryPosition";
// import ReusableFormExceptions from "../ReusableFormExceptions/ReusableFormExceptions";
import PopUpAsignament from "../PopUpAsignament/PopUpAsignament";
import EditRoutePosition from "../EditRoutePosition/EditRoutePosition";

import { DriversCards } from "./DriversCards";
import { obtenerHistorialDeOrden } from "../../hooks/useOrdersProviders/obtenerHistorialDeOrden";

const TabSecondary = lazy(() =>
  import("./TabSecondary").then((mod) => ({
    default: mod.default || mod.TabSecondary,
  }))
);

const MapDeliveryPosition = lazy(() => import("./MapDeliveryPosition"));

const ReusableFormExceptions = lazy(() =>
  import("../ReusableFormExceptions/ReusableFormExceptions")
);

const libraries = ["places", "geometry"];
const companyId = "77528497-8";
const COMPUTETIME = true;

const SectionLoader = ({ text = "Cargando..." }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
    <LinearProgress sx={{ flex: 1 }} />
    <Typography variant="body2" color="text.secondary">
      {text}
    </Typography>
  </Box>
);

const Fallback = ({ h }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: h,
    }}
  >
    <CircularProgress size={20} />
  </Box>
);

// Overlay no bloqueante para refrescos de sección
const SectionOverlay = ({ show, text = "Actualizando..." }) =>
  show ? (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        bgcolor: "rgba(255,255,255,0.6)",
        display: "flex",
        alignItems: "center",
        gap: 1,
        p: 2,
        zIndex: 5,
      }}
    >
      <CircularProgress size={18} />
      <Typography variant="body2" color="text.secondary">
        {text}
      </Typography>
    </Box>
  ) : null;

const Dispatchdetails = (props) => {
  // Carga del mapa (no bloquea la vista completa)

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_APIGOOGLEMAPS_MATRIX,
    libraries,
  });
  if (loadError) {
    // No bloquea, solo avisa en consola
    // eslint-disable-next-line no-console
    console.error("Google Maps load error:", loadError);
  }

  const navigate = useNavigate();

  // --- Métrica de tiempo de carga total (dev only)
  const tStartRef = useRef(Date.now());
  const [loadDoneAt, setLoadDoneAt] = useState(null);
  const [elapsedSec, setElapsedSec] = useState(0);

  const { id } = useParams();
  const { drivers, loading } = useDrivers(id);

  // --- Principales
  const [orderId, setOrderId] = useState("");
  const [orderDetails, setOrderDetails] = useState(null);
  const [orderDetailsCliente, setOrderDetailsCliente] = useState(null);

  // --- Datos derivados
  const [dispachtHistory, setDispachtHistory] = useState([]);
  const [compyOrder, setCompyOrder] = useState({});
  const [dataOrdesBicciExpress, setdataOrdesBicciExpress] = useState([]);

  // --- Soporte global mínimo
  const [isSending, setIsSending] = useState(false);
  const [findOrder, setFindOrder] = useState(null);

  // --- Comentarios
  const [userAdminComent, setUserAdminComent] = useState([]);
  const [newComent, setNewComent] = useState("");

  // --- Acciones
  const [openEdit, setOpenEdit] = useState(false);
  const [opemPopUpAsignament, setOpemPopUpAsignament] = useState(false);

  // --- Rider y acciones lote
  const [riderDestails, setRiderDestails] = useState({});
  const [routesOrdersForAccions, setRoutesOrdersForAccions] = useState([]);

  // --- Prefijos
  const [prefixes, setPrefixes] = useState([]);
  const [orderPrefix, setOrderPrefix] = useState(null);
  const orderPrefixRef = useRef(null);

  // --- Suscripción viva
  const unsubscribeRef = useRef(null);

  // --- Estados de carga por sección (no bloqueantes)
  const [docReady, setDocReady] = useState(false);
  const [companyReady, setCompanyReady] = useState(false);
  const [historyReady, setHistoryReady] = useState(false);
  const [ridersReady, setRidersReady] = useState(false);

  // Marca de “todo listo”: ajusta esta condición si quieres incluir/excluir secciones
  const allReady =
    docReady && companyReady && historyReady && ridersReady && isLoaded;

  // --- Busy flags por sección (refrescos sin borrar UI)
  const [docBusy, setDocBusy] = useState(false);
  const [historyBusy, setHistoryBusy] = useState(false);
  const [riderBusy, setRiderBusy] = useState(false);
  const [xlogs, setXlogs] = useState([]);

  // --- Proveedores
  const { companiesData } = useOrders({
    initDateInitial: Moment().format("YYYY-MM-DD"),
    endDateInitial: Moment().format("YYYY-MM-DD"),
  });
  const { ridersDataByCompany } = useGetDataRiderByCompany(companyId);

  // Riders map O(1) para historial (cuando llegue)
  const ridersById = useMemo(() => {
    const map = new Map();
    if (ridersDataByCompany?.length) {
      ridersDataByCompany.forEach((r) => map.set(r.id, r));
    }
    setRidersReady(true);
    return map;
  }, [ridersDataByCompany]);

  useEffect(() => {
    if (!COMPUTETIME) return;
    if (!loadDoneAt && allReady) {
      const t = Date.now();
      setLoadDoneAt(t);
      setElapsedSec((t - tStartRef.current) / 1000);
    }
  }, [allReady, loadDoneAt]);

  // Mientras no termina, actualiza el cronómetro en vivo
  useEffect(() => {
    if (!COMPUTETIME) return;
    if (loadDoneAt) return; // ya terminó

    const id = setInterval(() => {
      setElapsedSec((Date.now() - tStartRef.current) / 1000);
    }, 200);

    return () => clearInterval(id);
  }, [loadDoneAt]);

  // ID desde URL
  useEffect(() => {
    if (!id) return;
    const trimmed = id.trim();
    setOrderId(trimmed);
    setRoutesOrdersForAccions((prev) =>
      prev.includes(trimmed) ? prev : [trimmed]
    );
  }, [id]);

  // Prefijos desde compañías (sección independiente)
  useEffect(() => {
    if (!companiesData) return;
    const extracted = (companiesData || [])
      .filter((i) => i.prefix)
      .map((i) => i.prefix);
    setPrefixes(extracted);
    if (extracted.length > 0) setCompanyReady(true);
  }, [companiesData]);

  // Bootstrap + suscripción viva
  useEffect(() => {
    if (!orderId || prefixes.length === 0) return;

    getXpressLogs();

    let cancelled = false;
    const collections = [process.env.REACT_APP_COL_USERS_ORDERS];

    (async () => {
      try {
        // No borramos la UI existente; sólo marcamos busy
        setDocBusy(true);
        setHistoryBusy(true);

        const { foundDocumentData, documentHistory, prefix } =
          await getDocumentAndHistory(orderId, prefixes, collections, {
            historyLimit: 30,
            companiesData,
            altCollection: process.env.REACT_APP_COL_FALABELLA_ORDERS,
            mainHistorySub: "statuses",
            altHistorySub: "status",
            falabellaPrefix: "F",
          });

        if (foundDocumentData === null) {
          // console.log("aplica otras busquedas");
          // console.log("orderId, prefixes:", orderId, prefixes, companiesData);
          // console.log(props);

          // Si quieres limitar esto solo a ciertos roles:
          if (props.usuarioStorage.roll === process.env.REACT_APP_ADMIN) {
            try {
              // Buscar directo por ID en la colección base
              const directRef = doc(
                db,
                process.env.REACT_APP_COL_USERS_ORDERS,
                orderId
              );
              const directSnap = await getDoc(directRef);

              if (directSnap.exists() && !cancelled) {
                const directData = {
                  id: directSnap.id,
                  ...directSnap.data(),
                };

                console.log("Fallback por ID sin prefix/company:", directData);

                // Seteas igual que cuando foundDocumentData existe
                setOrderDetails(directData);
                setOrderDetailsCliente(directData);
                setFindOrder(true);
                setDocReady(true);

                // En estos docs no hay company/prefix:
                setCompyOrder(null);
                setCompanyReady(true);
                setOrderPrefix(undefined);

                // Si quieres suscripción viva específica para este doc "huérfano":
                if (unsubscribeRef.current) {
                  try {
                    unsubscribeRef.current();
                  } catch {}
                  unsubscribeRef.current = null;
                }

                unsubscribeRef.current = onSnapshot(directRef, (snap) => {
                  if (!snap.exists()) {
                    setFindOrder(false);
                    return;
                  }
                  const liveData = { id: snap.id, ...snap.data() };
                  setOrderDetails(liveData);
                  setOrderDetailsCliente(liveData);
                  setFindOrder(true);
                  setDocReady(true);
                  setDocBusy(false);
                });

                // Ojo: aquí puedes decidir NO llamar a subscribeDocumentAndHistory
                // y retornar antes para que no pise este comportamiento.
              }
            } catch (fbErr) {
              console.error("Error en fallback por ID:", fbErr);
            }
          }
        }

        if (cancelled) return;

        if (prefix) {
          if (orderPrefixRef.current !== prefix) {
            orderPrefixRef.current = prefix;
            setOrderPrefix(prefix);
          }
          const dataCompany = companiesData?.find?.((c) => c.prefix === prefix);
          if (dataCompany) {
            if (dataCompany.companyID === "90749000-9") {
              dataCompany.nonDelivery = translateStatesSendsFalabbelaSelector;
            }
            setCompyOrder((prev) =>
              prev?.companyID === dataCompany.companyID ? prev : dataCompany
            );
            setCompanyReady(true);
          }
        }

        console.log(foundDocumentData);
        if (foundDocumentData?.id) {
          setOrderDetails(foundDocumentData);
          setOrderDetailsCliente(foundDocumentData);
          setFindOrder(true);
          setDocReady(true);
        } else {
          setFindOrder(false);
        }

        if (Array.isArray(documentHistory)) {
          setDispachtHistory(documentHistory);
          setHistoryReady(true);
        }

        // listeners vivos
        if (unsubscribeRef.current) {
          try {
            unsubscribeRef.current();
          } catch {}
          unsubscribeRef.current = null;
        }

        unsubscribeRef.current = await subscribeDocumentAndHistory(
          orderId,
          prefixes,
          collections,
          ({ doc, history, prefix: livePrefix }) => {
            if (doc && doc.id) {
              setOrderDetails(doc);
              setOrderDetailsCliente(doc);
              setFindOrder(true);
              setDocReady(true);
              setDocBusy(false); // llegó actualización
            } else {
              setFindOrder(false);
            }

            if (Array.isArray(history)) {
              setDispachtHistory(history);
              setHistoryReady(true);
              setHistoryBusy(false);
            }

            if (livePrefix && livePrefix !== orderPrefixRef.current) {
              orderPrefixRef.current = livePrefix;
              setOrderPrefix(livePrefix);
              const dataCompany = companiesData?.find?.(
                (c) => c.prefix === livePrefix
              );
              if (dataCompany) {
                if (dataCompany.companyID === "90749000-9") {
                  dataCompany.nonDelivery =
                    translateStatesSendsFalabbelaSelector;
                }
                setCompyOrder(dataCompany);
                setCompanyReady(true);
              }
            }
          },
          {
            historyLimit: 30,
            altCollection: process.env.REACT_APP_COL_FALABELLA_ORDERS,
            altHistorySub: "status",
            mainHistorySub: "statuses",
            falabellaPrefix: "F",
            companiesData,
          }
        );
      } catch (err) {
        console.error("bootstrap+subscribe error:", err);
        setFindOrder(false);
      } finally {
        setDocBusy(false);
        setHistoryBusy(false);
      }
    })();

    return () => {
      cancelled = true;
      if (unsubscribeRef.current) {
        try {
          unsubscribeRef.current();
        } catch {}
        unsubscribeRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId, prefixes, companiesData]);

  // Rider (independiente; no bloquea UI)
  useEffect(() => {
    let mounted = true;
    const fetchRider = async (driverId) => {
      try {
        if (!driverId) return;
        setRiderBusy(true);
        const riderRef = doc(
          collection(db, process.env.REACT_APP_COL_USERS_DRIVERS),
          driverId
        );
        const snap = await getDoc(riderRef);
        if (!mounted) return;
        setRiderDestails(snap.data() || {});
      } catch {
      } finally {
        setRiderBusy(false);
      }
    };
    if (orderDetails?.driverID) fetchRider(orderDetails.driverID);
    if (!orderDetails?.driverID) setRiderDestails({});
    return () => {
      mounted = false;
    };
  }, [orderDetails?.driverID]);

  const handleClick = () => navigate(-1);

  const getXpressLogs = async () => {
    let xlog = await obtenerHistorialDeOrden(orderId);
    setXlogs(xlog);
  };

  // Comentarios con arrayUnion (más rápido y barato)
  const saveComentAdmin = async (e) => {
    e.preventDefault();
    const text = newComent.trim();
    if (!text || !orderId) return;
    try {
      setIsSending(true);
      const orderRef = doc(db, process.env.REACT_APP_COL_USERS_ORDERS, orderId);
      await updateDoc(orderRef, { observationAdmin: arrayUnion(text) });
      setUserAdminComent((prev) => [...(prev || []), text]);
      setNewComent("");
    } catch (err) {
      console.error("saveComentAdmin:", err);
    } finally {
      setIsSending(false);
    }
  };

  const saveValidatePickup = async () => {
    if (!orderDetails?.isPickedUp && orderId) {
      try {
        setIsSending(true);
        const orderRef = doc(
          db,
          process.env.REACT_APP_COL_USERS_ORDERS,
          orderId
        );
        await updateDoc(orderRef, { isPickedUp: true });
      } catch (error) {
      } finally {
        setIsSending(false);
      }
    }
  };

  // const onSave = async () => {
  //   try {
  //     setIsSending(true);
  //     await new Promise((r) => setTimeout(r, 250));
  //     setOpenEdit(false);
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     setIsSending(false);
  //   }
  // };
  const onSave = (payload) => {
    // payload viene desde ReusableFormExceptions con phase: "success"
    // aquí ya terminó el dispatch en el hijo

    // Opcional: apagar barra top si la enciendes al abrir modal
    setIsSending(false);

    // 👇 Optimista: agregas un log al listado de "Estados de Operaciones"
    if (!payload) return;

    const exceptionId =
      payload.exceptionID || payload.reasonCode || payload.status;

    setXlogs((prev) => [
      ...prev,
      {
        id: `${orderId}-${Date.now()}`,
        date: new Date(),
        name: props.firebaseUser?.displayName || "",
        exceptionID: exceptionId,
        status: payload.status,
      },
    ]);
  };

  const handleUpdate = async () => {
    try {
      // Refresh manual sin borrar UI
      setDocBusy(true);
      setHistoryBusy(true);
      const collections = [process.env.REACT_APP_COL_USERS_ORDERS];
      const { foundDocumentData, documentHistory } =
        await getDocumentAndHistory(orderId, prefixes, collections, {
          historyLimit: 30,
          companiesData,
          altCollection: process.env.REACT_APP_COL_FALABELLA_ORDERS,
          mainHistorySub: "statuses",
          altHistorySub: "status",
          falabellaPrefix: "F",
        });
      if (foundDocumentData?.id) {
        setOrderDetails(foundDocumentData);
        setOrderDetailsCliente(foundDocumentData);
        setFindOrder(true);
        setDocReady(true);
      }
      setDispachtHistory(documentHistory || []);
      setHistoryReady(true);
    } catch (e) {
      setDocReady(true);
      setHistoryReady(true);
    } finally {
      setDocBusy(false);
      setHistoryBusy(false);
    }
  };

  const formatDate = (ts) => {
    if (!ts) return "-";
    // Firestore Timestamp → Date
    const d = ts.toDate ? ts.toDate() : ts;
    return d.toLocaleString("es-CL");
  };

  // Top progress solo para escrituras; no bloquea secciones
  const showTopProgress = isSending;

  console.log(orderDetails);
  return (
    <>
      {showTopProgress && (
        <Box sx={{ position: "sticky", top: 0, zIndex: 2000 }}>
          <LinearProgress />
        </Box>
      )}

      {COMPUTETIME && (
        <Box
          sx={{
            position: "fixed",
            left: 8,
            bottom: 20,
            zIndex: 3000,
            bgcolor: "rgba(0,0,0,0.72)",
            color: "#fff",
            px: 1,
            py: 0.5,
            borderRadius: 1,
            fontSize: 12,
            fontFamily: "monospace",
            pointerEvents: "none",
            boxShadow: 3,
          }}
        >
          {loadDoneAt ? "Load: " : "Cargando… "}
          {elapsedSec.toFixed(2)}s
        </Box>
      )}

      {orderDetails ? (
        <Box
          id="containerDetails"
          sx={{
            textAlign: "left",
            borderRadius: "3px",
          }}
        >
          {ridersDataByCompany ? (
            <PopUpAsignament
              opemPopUpAsignament={opemPopUpAsignament}
              setOpemPopUpAsignament={setOpemPopUpAsignament}
              ordersForAccions={routesOrdersForAccions}
              ridersDataByCompany={ridersDataByCompany}
              handleUpdate={handleUpdate}
            />
          ) : null}

          <Grid2 container spacing={2} sx={{ p: 1, borderRadius: "3px" }}>
            {/* Columna izquierda */}
            <Grid2
              sx={{
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "65%",
                  borderRadius: "3px",
                },
                maxHeight: "100%",
              }}
            >
              <Card
                sx={{
                  p: 1,
                  boxShadow: 3,
                  borderRadius: "3px",
                  bgcolor: "background.paper",
                  position: "relative",
                }}
              >
                <SectionOverlay show={docBusy} text="Actualizando detalle..." />
                <CardHeader
                  title={
                    <Box sx={{ width: "100%", p: 1, justifyContent: "start" }}>
                      <Typography sx={{ color: "#030303", fontSize: "1.5em" }}>
                        Detalles de Despacho
                      </Typography>
                      <Divider />
                      <Typography
                        variant="h4"
                        align="left"
                        sx={{ mb: 2, fontWeight: "bold" }}
                      >
                        {orderDetails.id}
                      </Typography>
                      {!docReady && (
                        <SectionLoader text="Cargando detalle de la orden..." />
                      )}
                      {docReady && (
                        <Grid2
                          container
                          spacing={2}
                          alignItems="left"
                          justifyContent="start"
                        >
                          {/* Estado BICCI */}
                          <Grid2 xs={12} sm={6} md={4} textAlign="center">
                            <Typography
                              variant="h6"
                              sx={{
                                backgroundColor: "#F3F3F3",
                                borderRadius: "5px",
                                fontWeight: "bold",
                                fontSize: "1rem",
                                padding: "5px",
                                color: "#333",
                              }}
                              className={stlyleClassStates[orderDetails.status]}
                            >
                              {translateStatesBicciFilter[orderDetails.status]}
                            </Typography>
                          </Grid2>

                          {orderDetails.status !== 8 ? (
                            <>
                              <Grid2 xs={12} md={4} textAlign="center">
                                <Button
                                  fullWidth
                                  variant="contained"
                                  onClick={() => {
                                    const ok = window.confirm(
                                      "¿Estás seguro de que quieres validar que posees el producto físico?"
                                    );
                                    if (ok) saveValidatePickup();
                                  }}
                                  disabled={
                                    orderDetails.isPickedUp || isSending
                                  }
                                  sx={{
                                    backgroundColor: orderDetails.isPickedUp
                                      ? "green"
                                      : "orange",
                                    color: "white",
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                    padding: "5px",
                                    "&:hover": {
                                      backgroundColor: orderDetails.isPickedUp
                                        ? "darkgreen"
                                        : "darkorange",
                                    },
                                    "&.Mui-disabled": {
                                      backgroundColor: orderDetails.isPickedUp
                                        ? "green"
                                        : "orange",
                                      color: "white",
                                      opacity: 1,
                                    },
                                  }}
                                  startIcon={
                                    isSending ? (
                                      <CircularProgress size={14} />
                                    ) : null
                                  }
                                >
                                  {orderDetails.isPickedUp
                                    ? "Validación Picked: físico ok"
                                    : "Requiere validar físico"}
                                </Button>
                              </Grid2>

                              {orderDetailsCliente ? (
                                <Grid2>
                                  <Button
                                    onClick={() =>
                                      HandlePrintBiccShipping(
                                        orderDetails,
                                        orderDetailsCliente
                                      )
                                    }
                                    sx={{ width: "100%", fontSize: "1em" }}
                                  >
                                    <PrintIcon fontSize="medium" />
                                    Imprimir etiqueta
                                  </Button>
                                </Grid2>
                              ) : null}
                            </>
                          ) : null}
                        </Grid2>
                      )}
                      <div>
                        {orderDetails.status !== 8 ? (
                          <Grid2 xs={12} sm={6} md={4} textAlign="center">
                            <Typography
                              variant="h6"
                              sx={{
                                backgroundColor: "#F3F3F3",
                                borderRadius: "5px",
                                padding: "5px",
                                fontWeight: "bold",
                                color: "#333",
                              }}
                              className={styleState[orderDetails.intState]}
                            >
                              {orderDetails.intState} :
                              {translateStatesfalabbela[orderDetails.intState]}
                            </Typography>
                          </Grid2>
                        ) : null}
                      </div>
                    </Box>
                  }
                  sx={{
                    p: 1,
                  }}
                />

                <CardContent sx={{ p: 1 }}>
                  <Divider sx={{ my: 1 }} />
                  {!docReady ? (
                    <SectionLoader text="Cargando resumen..." />
                  ) : (
                    <Box sx={{ textAlign: "center" }}>
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        color="primary"
                      >
                        Detalles
                      </Typography>
                      <Box>
                        <Suspense fallback={<Fallback h={80} />}>
                          <>
                            <TabSecondary
                              orderDetails={orderDetails}
                              orderDetailsCliente={orderDetailsCliente}
                              dataOrdesBicciExpress={dataOrdesBicciExpress}
                              usuarioStorage={props.usuarioStorage}
                              setOrderDetails={setOrderDetails}
                            />
                          </>
                        </Suspense>
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid2>

            {/* Columna derecha */}
            <Grid2
              sx={{
                width: { xs: "100%", sm: "100%", md: "32%" },
                height: "95vh",
                overflowY: "scroll",
                p: 1,
              }}
            >
              {/* Observación / Comentarios */}
              <Box
                sx={{
                  maxHeight: 300,
                  overflowY: "auto",
                  backgroundColor: "#f8f8f8",
                }}
              >
                <CardHeader
                  title={
                    <h3 style={{ color: "black" }}>Estados de Operaciones :</h3>
                  }
                />
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Fecha</TableCell>
                      <TableCell>Nombre</TableCell>
                      <TableCell>Estado Enviado</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {xlogs.map((log) => (
                      <TableRow key={log.id}>
                        <TableCell>{formatDate(log.date)}</TableCell>
                        <TableCell>{log.name || "-"}</TableCell>
                        <TableCell>
                          {translateStatesfalabbela[log.exceptionID] ||
                            log.status ||
                            "-"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
              <Card
                className="card-ultimasOrdenes typeMiniforms"
                sx={{ position: "relative" }}
              >
                <SectionOverlay
                  show={docBusy}
                  text="Actualizando observaciones..."
                />

                <CardContent sx={{ p: 0 }}>
                  {!docReady ? (
                    <SectionLoader text="Cargando observaciones..." />
                  ) : (
                    <Box
                      sx={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                        maxWidth: "150",
                        p: 0,
                      }}
                    >
                      <ContainerViewComponent>
                        <hr />
                        <Typography fontFamily="Lato, Arial, Helvetica, sans-serif">
                          Rider:{" "}
                        </Typography>
                        <div fontFamily="Lato, Arial, Helvetica, sans-serif">
                          {orderDetails.observationReceptor ? (
                            <p className="color-blue">
                              {orderDetails.observationReceptor}
                            </p>
                          ) : (
                            "Sin Comentarios"
                          )}
                        </div>
                        <hr />
                        Admin:
                        {orderDetails.observationAdmin &&
                        orderDetails.observationAdmin.length > 0
                          ? orderDetails.observationAdmin.map((item, index) => (
                              <div key={index} className="color-blue">
                                <hr />
                                <div>{item}</div>
                              </div>
                            ))
                          : " Sin Comentarios"}
                        <hr />
                        Agregar comentario a la Orden
                        <div>
                          <Box
                            component="form"
                            onSubmit={saveComentAdmin}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <TextField
                              placeholder="Agregar comentario"
                              variant="outlined"
                              type="text"
                              fullWidth
                              onChange={(e) => setNewComent(e.target.value)}
                              value={newComent}
                              InputProps={{ startAdornment: <EditIcon /> }}
                            />
                            <Button
                              sx={{
                                backgroundColor: "#591E8F",
                                color: "#fff",
                                marginTop: "30px",
                                ":hover": {
                                  backgroundColor: "#25b2f4 !important",
                                  color: "#591e8f",
                                },
                              }}
                              color="primary"
                              variant="contained"
                              type="submit"
                              disabled={isSending || !newComent.trim()}
                              startIcon={
                                isSending ? (
                                  <CircularProgress size={14} />
                                ) : null
                              }
                            >
                              Guardar Nota de Orden
                            </Button>
                          </Box>
                        </div>
                        <hr />
                        <Box sx={{ display: "flex" }}>
                          <Button
                            sx={{
                              backgroundColor: "#591E8F",
                              border: "none",
                              borderRadius: "3px",
                              color: "#fff",
                              cursor: "pointer",
                              fontSize: "14px",
                              marginTop: "30px",
                              outline: "none",
                              padding: "5px",
                              minWidth: "50px",
                              fontWeight: 400,
                              margin: "0em 1em 0em 0em",
                              ":hover": {
                                backgroundColor: "#25b2f4 !important",
                                color: "#591e8f",
                              },
                            }}
                            onClick={() => setOpenEdit(true)}
                            color="primary"
                            variant="contained"
                            type="button"
                            disabled={
                              !companyReady ||
                              isSending ||
                              !compyOrder?.nonDelivery
                            }
                            startIcon={
                              isSending ? <CircularProgress size={14} /> : null
                            }
                          >
                            {companyReady && compyOrder?.nonDelivery ? (
                              "Enviar Excepción"
                            ) : (
                              <>
                                <CircularProgress
                                  size={12}
                                  sx={{ color: "#fff" }}
                                />
                                &nbsp;Cargando
                              </>
                            )}
                          </Button>

                          <Button
                            sx={{
                              backgroundColor: "#591E8F",
                              border: "none",
                              borderRadius: "3px",
                              color: "#fff",
                              cursor: "pointer",
                              fontSize: "14px",
                              marginTop: "30px",
                              outline: "none",
                              padding: "5px",
                              minWidth: "50px",
                              fontWeight: 400,
                              margin: "0em 1em 0em 0em",
                              ":hover": {
                                backgroundColor: "#25b2f4 !important",
                                color: "#591e8f",
                              },
                            }}
                            onClick={() => setOpemPopUpAsignament(true)}
                            color="primary"
                            variant="contained"
                            type="button"
                          >
                            Asignar conductor
                          </Button>

                          <Suspense fallback={<Fallback h={80} />}>
                            <EditRoutePosition orderID={orderDetails.id} />
                          </Suspense>
                          <Suspense fallback={<Fallback h={80} />}>
                            {companyReady && compyOrder?.nonDelivery ? (
                              <ReusableFormExceptions
                                compyOrder={compyOrder}
                                open={openEdit}
                                handleClose={() => setOpenEdit(false)}
                                onSave={onSave}
                                orderID={orderDetails.id}
                                riderDestails={
                                  riderDestails?.driverLocation
                                    ? riderDestails.driverLocation
                                    : null
                                }
                                user={props.firebaseUser}
                              />
                            ) : null}
                          </Suspense>
                        </Box>
                        <hr />
                        <Box sx={{ mt: 1 }}>
                          <LiberarOrden
                            orderID={orderDetails.id}
                            userID={props.usuarioStorage.uid}
                            firebaseUser={props.firebaseUser}
                          />
                        </Box>
                      </ContainerViewComponent>
                    </Box>
                  )}
                </CardContent>
              </Card>

              {/* Geo referencia */}
              <Card
                className="card-ultimasOrdenes typeMiniforms"
                sx={{ mt: 2 }}
              >
                <CardHeader title={<h3>Geo referencia</h3>} />
                <CardContent>
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      maxWidth: "350",
                    }}
                  >
                    <Suspense fallback={<Fallback h={80} />}>
                      <MapDeliveryPosition
                        markersPending={orderDetails}
                        dispachtHistory={dispachtHistory}
                        riderDestails={riderDestails}
                        isLoaded={isLoaded}
                        libraries={libraries}
                      />
                    </Suspense>
                  </Box>
                </CardContent>
              </Card>

              {/* Historial */}
              <Card
                className="card-ultimasOrdenes typeMiniforms"
                sx={{ mt: 2, position: "relative" }}
              >
                <SectionOverlay
                  show={historyBusy}
                  text="Actualizando historial..."
                />
                <CardHeader title={<h3>Historial eventos</h3>} />
                <CardContent>
                  {!historyReady ? (
                    <SectionLoader text="Cargando historial..." />
                  ) : (
                    <Box
                      sx={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Box className="formcontent" id="micuentafromIni">
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Fecha</TableCell>
                              <TableCell>Conductor</TableCell>
                              <TableCell>Estado</TableCell>
                              <TableCell>Integracion</TableCell>
                            </TableRow>
                          </TableHead>

                          {dispachtHistory.length > 0 ? (
                            <TableBody>
                              {dispachtHistory.map((item, index) => {
                                const driver = ridersById.get(item.driverID);
                                const tsMs = item?.createdAt?.seconds
                                  ? item.createdAt.seconds * 1000
                                  : typeof item?.createdAt?.toMillis ===
                                    "function"
                                  ? item.createdAt.toMillis()
                                  : Date.now();

                                return (
                                  <TableRow key={item.id || index}>
                                    <TableCell>
                                      {format(tsMs, "dd/MM/yy HH:mm:ss")}
                                    </TableCell>
                                    <TableCell>
                                      {item.driverID
                                        ? driver
                                          ? driver.name
                                          : item.driverID
                                        : "Sistema"}
                                    </TableCell>
                                    <TableCell>
                                      {translateStatesBicciFilter[item.status]}
                                    </TableCell>
                                    <TableCell>
                                      {translateStatesfalabbela[item.status]}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          ) : (
                            <TableBody>
                              <TableRow>
                                <TableCell colSpan={4} align="center">
                                  No hay historial disponible
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          )}
                        </Table>
                      </Box>
                    </Box>
                  )}
                </CardContent>
              </Card>

              <DriversCards
                drivers={drivers}
                loading={loading || riderBusy}
                ridersDataByCompany={ridersDataByCompany}
              />
            </Grid2>
          </Grid2>
        </Box>
      ) : (
        // Carátula inicial / no encontrada (no bloqueante)
        <Card>
          <CardHeader title={"Esperando resultados"} />
          <CardContent>
            <div className="card-body">
              {findOrder ? (
                <Box>
                  <Box>
                    <img
                      src="/static/images/asset/enapuros.webp"
                      alt="Cargando..."
                      style={{ width: "100px", height: "100px" }}
                    />{" "}
                    No se encontró información...
                  </Box>
                </Box>
              ) : (
                <>
                  {findOrder === false ? (
                    <p className="card-text">
                      No se encontraron resultados{" "}
                      <span
                        role="img"
                        aria-label="Nerd face"
                        className="bigFace"
                      >
                        😕
                      </span>{" "}
                      que coincidan con su búsqueda. Verifique el código o
                      consulte si la orden fue creada correctamente.
                      <br />
                      <span
                        role="img"
                        aria-label="Nerd face"
                        className="bigFace"
                      >
                        🤓
                      </span>
                    </p>
                  ) : (
                    <>
                      <img
                        src="/static/images/asset/enapuros.webp"
                        alt="Buscando..."
                        width="70"
                      />{" "}
                      Buscando...
                    </>
                  )}
                </>
              )}
              <hr />
              <button
                type="button"
                className="btn btn-ebiex m-1"
                onClick={handleClick}
              >
                Regresar
              </button>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default Dispatchdetails;
